import styles from './LineBreak.module.scss';

export default function LineBreak() {
  return <div className={styles.lineBreak} />;
}
